module.exports = __webpack_public_path__ + "static/media/record-right.84ce28c9fb8e7ceb30adddcffc34fbfc.png";